import { Component, Input } from '@angular/core';
import { AssetUIModel } from '@thehubz/client/core';

@Component({
  selector: 'sp-plan-deletion-warning',
  templateUrl: './plan-deletion-warning.component.html',
})
export class PlanDeletionWarningComponent {
  @Input() asset!: AssetUIModel;

  textDeletionOn = $localize`Deletion on`;
}
